import { PrintableDocumentType, PrintLogResponse, PrintResponse, PrintTypeForm } from "../models/Prints";
import { HTTPClient } from "@abaco/web-common/src/HTTP";

export default class PrintApi {
    private http: HTTPClient;
    private treatmentAPi: string;

    constructor(http: HTTPClient, treatmentAPi: string) {
        this.http = http;
        this.treatmentAPi = treatmentAPi;
    }

    async insertPrint(printTypeId: string, printForm: PrintTypeForm): Promise<PrintResponse> {
        const res = await this.http.post(
            `/sitiagri-rest-api/api_basic/v1/services/print/scheduled_print/${printTypeId}`,
            printForm
        );
        return res.data;
    }

    async getDraftPrints(printLogId: number): Promise<PrintLogResponse> {
        const res = await this.http.get(
            `/sitiagri-rest-api/api_basic/v1/services/print/scheduled_print/queued/${printLogId}`
        );
        return res.data;
    }

    async getPrintableDocs(brgId: number): Promise<PrintableDocumentType[]> {
        const res = await this.http.get(`${this.treatmentAPi}/v1/brgTypes/${brgId}/printableDocuments`);
        return res.data.printableTemplates;
    }
}
// "params":[{"param_name":"SUBJECT_ID","param_val":529769},{"param_name":"BRG_ID","param_val":2002},{"param_name":"USER_ID","param_val":"ADMIN"},{"param_name":"CAMPAIGN","param_val":2023}]}

// https://devs4f.fe.abacogroup.eu/sitiagri-rest-api/api_basic/v1/services/print/scheduled_print/BRG_PRINT_TIMESHEET
